class ContactAddAcceptLink {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const dateWrap = "." + this.el;
    $(dateWrap).each(function(){
      let acceptText = $(this).find('.mwform-checkbox-field-text').html();
      let toPP = $(this).data('accept');
      let replaceText = '個人情報の取り扱い';
      let completeText = acceptText.replace(replaceText,'<a href="'+toPP+'" target="_blank">個人情報の取り扱い</a>');
      $(this).find('.mwform-checkbox-field-text').html(completeText);
    })
  }
}
